const CustomButton = ({label, onClick, className}) => {
  return (
    <div 
      onClick={onClick}
      className={`w-full py-4 text-white rounded-xl transition cursor-pointer ${className}`}>
      <div className="flex justify-center font-bold text-lg  dark:text-white border border-x-green-500 rounded-xl bg-blue-500 p-2 hover:bg-blue-400">
        {label}
      </div>
      
    </div>
  )
}

export default CustomButton